import React from 'react';
import './loader.css';

const Loader = ({ inline = false, label = 'Loading data…' }) => (
    <div className={inline ? 'loading-state' : 'overlay-bg'} role="status" aria-live="polite" aria-busy="true">
        <div className="loading-state-content">
            <div className="loader" aria-hidden="true" />
            <span>{label}</span>
        </div>
    </div>
);

export default Loader;
